import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layoutBushido"
import SEO from "../components/seo"

import "../styles/global.css"

const BushidoPage = () => (
  <>
  <SEO title="Osobná Značka a Marketing pre Freelancerov" keywords={[`online bodyguard, freelance zasady, tatransky freelancer, marketer na volnej nohe, dusan nic nebavi`]} />
  <Layout />
  </> 
)

export default BushidoPage
